import Routes from './routes/Routes'
import { AuthProvider } from './contexts/AuthContext/AuthContext'
import { ApolloProvider } from '@apollo/client'
import { BrowserRouter } from 'react-router-dom'
import client from './graphql/apolloClient'

function AppContent() {
  return (
    <>
      <Routes />
    </>
  )
}

function App() {
  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </BrowserRouter>
    </ApolloProvider>
  )
}

export default App
